import { render } from "./SocialNetworks.vue?vue&type=template&id=3da4dcae"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"
script.render = render

export default script